<template>
  <header-title />
  <div class="container">
    <aside-body />
    <div class="main">
      <div class="main" style="margin-left: 30px; margin-top: 30px;">
        <el-col :span="24">
          <!-- <el-input v-model="queryData.search" placeholder="请输入要查找的问题" class="input-side" /> -->
          <!-- <el-button type="primary" round @click="_searchPage()">搜索</el-button> -->
          <el-button type="warning" round @click="_editPage">新增</el-button>
        </el-col>
        <el-table :data="asks" stripe style="width: 100%;" scrollbar-always-on>
          <!-- <el-table-column prop="s_id" label="id" width="60" /> -->
          <el-table-column prop="s_name" label="问题" width="230" />
          <el-table-column prop="s_creation_time" label="发布日期" width="230" />
          <el-table-column fixed="right" label="操作" width="300">
            <template v-slot="scope">
              <el-button @click="_editPage(scope.row.s_id)" round type="primary">编辑</el-button>
              <el-button @click="_resultPage(scope.row.s_id)" round type="success">查看调查结果</el-button>
              <el-button round type="danger" @click="_deleteAnswer(scope.row.s_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import headerTitle from '@/components/headerTitle.vue';
import asideBody from '@/components/asideBody.vue';

export default {
  name: 'editQuestionView',
  components: { asideBody, headerTitle },
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style scoped></style>
